var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTierDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1239 1239",
    style: {
      enableBackground: "new 0 0 1239 1239"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007DAD;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 619.5,
    cy: 619.5,
    r: 619.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M763.5,312H475.5h0c-17.3,0-32.7,0-45.6,1.2c-14,1.3-27.7,4.1-41.2,11.2c-13.5,7.1-23.7,16.6-32.8,27.4 c-8.4,9.9-17.2,22.5-27.1,36.7v0l-0.8,1.2l-21.7,31l-1.1,1.6c-14,20-26.3,37.5-34.7,53.1c-9.1,16.8-15.6,34.7-15,55.5 c0.6,20.8,8.1,38.2,18.2,54.5c9.3,15.1,22.6,31.8,37.8,51l194.1,245.1l0,0c12.6,16,23.4,29.5,32.9,39.9c9.9,10.7,20.9,20.7,35,27.3 c29.3,13.7,63.2,13.7,92.5,0c14-6.6,25-16.6,35-27.3c9.6-10.4,20.3-23.9,32.9-39.9l194.1-245.1h0c15.2-19.2,28.4-35.9,37.8-51 c10.1-16.3,17.6-33.7,18.2-54.5c0.6-20.8-5.9-38.7-15-55.5c-8.4-15.6-20.7-33.1-34.7-53.1l-23.7-33.8c-9.9-14.2-18.7-26.8-27.1-36.7 c-9.1-10.8-19.3-20.3-32.8-27.4c-13.5-7.1-27.2-9.9-41.2-11.2C796.2,312,780.8,312,763.5,312L763.5,312z M540.6,495.9 c11.1-16.7,6.6-39.3-10.1-50.5c-16.7-11.1-39.3-6.6-50.5,10.1l-18.2,27.3c-19.7,29.6-17.6,68.7,5.1,96l70,84 c12.9,15.4,35.8,17.5,51.3,4.7c15.4-12.9,17.5-35.8,4.7-51.3l-70-84c-2.1-2.6-2.3-6.2-0.5-9L540.6,495.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierDiamond);
export default __webpack_public_path__ + "static/media/tier_diamond.d5706ce8080f808c2b4e92adb1f1d03b.svg";
export { ForwardRef as ReactComponent };